export function navegarAtePagina(navigate: any, caminho:string | number) {
  
  navigate(caminho);
}
